module.exports = __webpack_public_path__ + "static/img/scaff-64.2469562.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scaff-64.jpg
// module id = 241
// module chunks = 1